import { Linkedin, Youtube } from "lucide-react";

import { cn } from "@/lib/utils";

import type { SocialLinkIconProps } from "./SocialLinkIcon.types";

const iconClassName = "size-4 shrink-0";

const XIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden
    className={className}
    fill="currentColor"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const TikTokIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden
    className={className}
    fill="currentColor"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.77 1.52V6.76a4.85 4.85 0 0 1-1-.07z" />
  </svg>
);

export const SocialLinkIcon = ({ id, className }: SocialLinkIconProps) => {
  const mergedClassName = cn(iconClassName, className);

  switch (id) {
    case "x":
      return <XIcon className={mergedClassName} />;
    case "linkedin":
      return <Linkedin className={mergedClassName} aria-hidden />;
    case "youtube":
      return <Youtube className={mergedClassName} aria-hidden />;
    case "tiktok":
      return <TikTokIcon className={mergedClassName} />;
  }
};
